import { locationDescriptorRemovingBasePath } from './utils';
import { useRouter } from '../router';
export function useHistory() {
  const nextRouter = useRouter();
  return {
    // TODO: `fn` here should probably have type History.LocationListener<S>
    // but that raises the question of where we get the Location and Action
    // arguments it expects. Is it an actual bug that we're not passing
    // those currently? Out of scope for current changes but worth a later
    // investigation.
    listen(fn) {
      const handler = () => fn();
      nextRouter.events.on('routeChangeStart', handler);
      return () => {
        nextRouter.events.off('routeChangeStart', handler);
      };
    },
    replace(location, _state) {
      return nextRouter.replace(locationDescriptorRemovingBasePath(location, nextRouter.basePath));
    },
    push(location, _state) {
      return nextRouter.push(locationDescriptorRemovingBasePath(location, nextRouter.basePath));
    }
  };
}